import { Button, Col, Row, Table, Typography } from "antd";
import { FaEdit } from "react-icons/fa";
import moment from "moment";
import Title from "antd/es/typography/Title";
import { ModalFormNoticia } from "./components/ModalFormNoticia";
import { ModalImagem } from "./components/ModalImagem";
import useNoticias from "./useNoticias";
import Loading from "../../components/Loading";

export default function Noticias() {

    const {
        dataEntity,
        userCan,
        setIsEditarNoticia,
        formNoticia,
        setFileList,
        refFileList,
        setNoticiaDescricao,
        showModalNoticia,
        columnsNoticias,
        noticias,
        isLoading,
        theme,
        refContagemDoFiltroNoticias,
        isModalImagemOpen,
        handleImagemCancel,
        imagemModal,
        isEditarNoticia,
        isModalNoticiaOpen,
        handleNoticiaCancel,
        refFormNoticia,
        handleChangeImagensNoticia,
        fileList,
        setImagemModal,
        setIsModalImagemOpen,
        uploadImagensNoticia,
        onClickBotaoSalvarNoticia,
        noticiaDescricao,
        handleEditorContentChange,
        removerImagemNoticia,
        visibleDatePicker,
        onVisibleDatePicker,
        defaultValueDatePicker,
    } = useNoticias();

    if (!dataEntity?.entity?.id) {
        return (
            <>
                <Title level={3}>Cadastre o institucional antes de inserir as notícias.</Title>
            </>
        );
    }

    if (!userCan('manage_news')) {
        return (
            <>
                <Title level={3}>Você não tem permissão para acessar essa página.</Title>
            </>
        );
    }

    return (
        <Loading loading={isLoading}>
            <Title level={3}>Notícias</Title>
            <Row style={{ marginTop: 10 }}>
                <Col
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <Button
                        type="primary"
                        onClick={() => {
                            setIsEditarNoticia(false);
                            formNoticia?.setFieldsValue({
                                idNoticia: "",
                                tituloNoticia: "",
                                linkNoticia: "",
                                categoriaNoticia: "",
                                destaqueNoticia: "Não",
                                descricaoNoticia: "",
                                imagensNoticia: "",
                                // dataNoticia: datejs,
                            });
                            setFileList([]);
                            refFileList.current = []
                            setNoticiaDescricao("");
                            showModalNoticia();
                        }}
                    >
                        <FaEdit />
                        Adicionar Notícia
                    </Button>
                </Col>
            </Row>
            {/* div pra responsive */}
            <div style={{ overflowX: "auto" }}>
                <Table
                    style={{
                        // marginTop: 50,
                    }}
                    columns={columnsNoticias}
                    dataSource={noticias.map((item) => ({ ...item, key: item.id.toString() }))}
                    // rowSelection={rowSelection}
                    // loading={isLoading}
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor:
                                        theme === "light"
                                            ? "#FAFAFA"
                                            : "#1D1D1D",
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5,
                                }}
                            >
                                <Typography>
                                    {`Mostrando: ${registros.length
                                        } de ${refContagemDoFiltroNoticias
                                            .current.length === 0
                                            ? noticias.length
                                            : refContagemDoFiltroNoticias
                                                .current.length
                                        } num total de ${noticias.length
                                        } `}
                                </Typography>
                            </div>
                        );
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: "end",
                                }}
                            >
                                <Typography
                                >
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registros.length
                                        } de ${refContagemDoFiltroNoticias
                                            .current.length === 0
                                            ? noticias.length
                                            : refContagemDoFiltroNoticias
                                                .current.length
                                        } num total de ${noticias.length
                                        } `}
                                </Typography>
                            </div>
                        );
                    }}
                    pagination={{
                        locale: { items_per_page: "" },
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        position: ["topRight", "bottomRight"],
                        pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                >

                </Table>
            </div>


            <ModalImagem
                isOpen={isModalImagemOpen}
                handleCancel={handleImagemCancel}
                srcImage={imagemModal}
            />

            <ModalFormNoticia
                isEditarNoticia={isEditarNoticia}
                isModalNoticiaOpen={isModalNoticiaOpen}
                handleNoticiaCancel={handleNoticiaCancel}
                formNoticia={formNoticia}
                refFormNoticia={refFormNoticia}
                handleChangeImagensNoticia={handleChangeImagensNoticia}
                fileList={fileList}
                setImagemModal={setImagemModal}
                setIsModalImagemOpen={setIsModalImagemOpen}
                uploadImagensNoticia={uploadImagensNoticia}
                loadingPage={isLoading}
                onClickBotaoSalvarNoticia={onClickBotaoSalvarNoticia}
                noticiaDescricao={noticiaDescricao}
                onEditorContentChange={handleEditorContentChange}
                removerImagemNoticia={removerImagemNoticia}
                visibleDatePicker={visibleDatePicker}
                onVisibleDatePicker={onVisibleDatePicker}
                defaultValueDatePicker={defaultValueDatePicker}
            />
        </Loading>
    );
}
